import React from 'react';
import { TextField, Button } from '@mui/material';
import type { SearchBarProps } from './types';
import './UserAccess.css';

export const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  loading,
  onSearchChange,
  onReset,
}) => {
  return (
    <div className="user-access-search-bar">
      <TextField
        id="user-access-search"
        label="Search By Email"
        variant="standard"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="user-access-search-bar__input"
        disabled={loading}
      />
      <Button
        variant="outlined"
        onClick={onReset}
        disabled={loading || !searchQuery}
        size="small"
        className="user-access-search-bar__reset-btn"
      >
        Reset
      </Button>
    </div>
  );
};